<template>
  <div class="procard_wrap">
    <div class="procard_btn">
      <div class="procard_item" v-for="(item, index) in procardList" :key="index"
        :class="activeIndex === index ? 'active' : ''" @click="changeIndex(index)">
        {{ item.tit }}
      </div>
    </div>
    <div class="procard_content">
      <div class="content_left">
        <div class="left_tit">{{ prodProp[activeIndex]?.title }}</div>
        <div class="left_icon_wrap">
          <div class="icon_item" v-for="(item, index) in prodProp[activeIndex]?.children || []" :key="index" ref="iconItem">
            <el-tooltip class="item" effect="dark" :content="item.tip" placement="top-start" :disabled="disableTips">
              <div>
                <i :class="item.src" class="iconfont"></i>
                <span v-html="item.subTitle"></span>
              </div>
            </el-tooltip>
          </div>
        </div>
        <!-- <router-link class="left_btn hidden-xs-only" to="/demo">立即体验</router-link> -->
      </div>
      <div class="content_right">
        <img :src="prodProp[activeIndex]?.image" alt="" />
        <!-- <router-link class="left_btn hidden-sm-and-up" to="/demo">立即体验</router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      disableTips: true,
    }
  },
  props: {
    procardList: {
      type: Array,
      default: [],
    },
    prodProp: {
      type: Array,
      default: [],
    },
  },
  methods: {
    changeIndex(index) {
      this.activeIndex = index
    },
  },
}
</script>

<style lang="scss" scoped>
.procard_wrap {
  width: 70%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.02) inset;

  @media screen and (max-width: 768px) {
    width: 95%;
    background: #f7f7f7;
  }

  .procard_btn {
    width: 100%;
    display: flex;

    .procard_item {
      flex: 1;
      height: 80px;
      background: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      position: relative;
      cursor: pointer;

      @media screen and (max-width: 768px) {
        height: 60px;
        text-align: center;
        font-size: 12px;
      }
    }

    .active {
      color: #fff;
      background: #2091d3;
      font-weight: bold;

      &::before {
        content: '▲';
        position: absolute;
        color: #2091d3;
        font-size: 40px;
        transform: rotateX(180deg);
        bottom: -27px;
      }
    }
  }

  .procard_content {
    width: 100%;
    display: flex;
    padding: 30px;
    justify-content: center;

    @media screen and (max-width: 768px) {
      flex-direction: column;
    }

    .content_left {
      width: 45%;

      @media screen and (max-width: 768px) {
        width: 100%;
      }

      .left_tit {
        color: #2d3937;
        font-size: 17px;
        min-height: 90px;
        line-height: 1.5rem;

        @media screen and (max-width: 768px) {
          font-size: 0.9rem;
          padding: 10px 20px;
          color: #646464;
        }
      }

      .left_icon_wrap {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        padding-bottom: 30px;

        @media screen and (max-width: 768px) {
          justify-content: space-around;
        }

        .icon_item {
          width: 30%;
          height: 50px;
          display: flex;
          align-items: center;
          background: #FFFFFF;
          box-shadow: 10px 10px 20px rgba($color: #000000, $alpha: 0.1);
          padding: 5px;
          box-sizing: content-box;
          cursor: pointer;

          &:nth-child(n + 4) {
            margin-top: 1rem;
          }

          @media screen and (max-width: 768px) {
            height: 50px;
            justify-content: center;
          }

          i {
            color: #7bbde3;
            font-size: 24px;

            @media screen and (max-width: 768px) {
              font-size: 20px;
            }
          }

          span {
            color: #646464;
            font-size: 16px;
            padding: 0 10px;

            @media screen and (max-width: 768px) {
              font-size: 14px;
            }
          }
        }
      }

      .left_btn {
        width: 180px;
        height: 50px;
        background: orange;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;
      }
    }

    .content_right {
      width: 40%;

      @media screen and (max-width: 768px) {
        width: 100%;
        text-align: center;
      }

      text-align: right;

      img {
        margin-top: 30px;
        width: 50%;
      }

      .left_btn {
        width: 180px;
        height: 50px;
        background: orange;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;

        @media screen and (max-width: 768px) {
          width: 90px;
          height: 35px;
          font-size: 14px;
          border-radius: 20px;
          margin: 20px auto;
        }
      }
    }
  }
}
</style>